import { useEffect, useState } from "react";
import { getUser } from "../../auth";
import StockTableUI from "../components/StockTableUI";
import socket from "../../socket";

const URL = process.env.REACT_APP_API_URL;

export default function StockTable() {
  const [data, setData] = useState([]);
  
  const fetchStock = async () => {
    const user = getUser();
    try {
      const response = await fetch(
        `${URL}/api/stock/?empresa_id=${user.empresa_id}`
      );
      if (response.ok) {
        const stockData = await response.json();
        setData(stockData);
      } else {
        console.error("Error al obtener los datos de stock");
      }
    } catch (error) {
      console.error("Error de red al obtener los datos de stock", error);
    }
  };

  useEffect(() => {
    fetchStock();

    socket.on("stock_creado", () => {
      fetchStock();
    })

    socket.on("stock_entrada_registrada", () => {
      fetchStock();
    })

    socket.on("stock_eliminado", () => {
      fetchStock();
    })

    return () => {
      socket.off("stock_creado");
      socket.off("stock_entrada_registrada");
      socket.off("stock_eliminado");
    }
  }, []);

  const headerData = [
    "Producto",
    "Tipo",
    "Stock actual",
    "Stock mínimo",
    "Precio unitario",
    "Última entrada",
    "Estado",
  ];

  return (
    <StockTableUI
      headerData={headerData}
      data={data}
    />
  )
}